import React from 'react';
import propellerIcon from '../images/PROPELLER_ICON.svg';


const LoadingSpinner: React.FC = () => {
  return (
    <div className='d-flex justify-content-center vh-100'>
      {/* <div id="circularG">
        <div id="circularG_1" className="circularG"></div>
        <div id="circularG_2" className="circularG"></div>
        <div id="circularG_3" className="circularG"></div>
        <div id="circularG_4" className="circularG"></div>
        <div id="circularG_5" className="circularG"></div>
        <div id="circularG_6" className="circularG"></div>
        <div id="circularG_7" className="circularG"></div>
        <div id="circularG_8" className="circularG"></div>
      </div> */}
      <div className='loading-spinner'>
        <img src={propellerIcon} alt="Loading.." />
      </div>
    </div>
  );
};

export default LoadingSpinner;